module.exports = __webpack_public_path__ + "public/images/step-1.96924bce338d4dc5683030743a4fd89c.png";